<template>
  <v-card>
    <v-toolbar color="indigo" elevation="4">
      <v-toolbar-title class="toolbar-title">Metrics Viewer</v-toolbar-title>
    </v-toolbar>
    <v-container class="d-flex justify-center">
      <v-btn @click="navigateToCopilot" color="blue" class="metrics-button">Copilot Metrics</v-btn>
      <v-btn @click="navigateToNCode" color="green" class="metrics-button">nCode Metrics</v-btn>
    </v-container>
  </v-card>
</template>

<script lang='ts'>
import { defineComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'EntryPage',
  setup() {
    const router = useRouter();

    onMounted(() => {
      console.log('EntryPage mounted');
    });

    const navigateToCopilot = () => {
      router.push('/copilot');
    };

    const navigateToNCode = () => {
      router.push('/ncode');
    };

    return {
      navigateToCopilot,
      navigateToNCode,
    };
  },
});
</script>

<style scoped>
.metrics-button {
  margin: 10px;
  width: 200px;
}
</style> 